import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaQuestionCircle,
  FaClipboardList,
  FaClipboardCheck,
  FaHandHoldingHeart,
  FaHandHoldingWater,
  FaCoins,
  FaUserFriends,
  FaFolderOpen,
} from 'react-icons/fa';
import {
  getProgramSubNavItems,
  resolveProgramSubNavItems,
  resolveProgramSubNavPath,
  PROGRAM_TITLES,
} from '../config/programSubNav';
import { usePublicLocale, usePublicPaths } from '../routes/publicPaths';
import { tProgramNavLabel } from '../utils/publicI18n';
import { scrollToProgramSection } from '../utils/programScroll';
import './ProgramSubNav.css';

export const PROGRAM_SUBNAV_ICONS = {
  question: FaQuestionCircle,
  water: FaHandHoldingWater,
  current: FaClipboardList,
  completed: FaClipboardCheck,
  donate: FaHandHoldingHeart,
  coins: FaCoins,
  sponsor: FaUserFriends,
  files: FaFolderOpen,
};

const ProgramMegaMenuLinks = ({ slug, title, variant = 'subnav', activeHash, subNavItems, program, onNavigate }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const locale = usePublicLocale();
  const paths = usePublicPaths();
  const items = subNavItems?.length
    ? subNavItems
    : program
      ? resolveProgramSubNavItems(program)
      : getProgramSubNavItems(slug, title || PROGRAM_TITLES[slug]);
  const basePath = paths.programme(slug);
  const onSamePage = location.pathname === basePath;
  const hash = activeHash ?? (onSamePage ? location.hash : '');

  const listClass = variant === 'mega' ? 'site-mega-menu__list' : 'program-subnav__list';
  const itemClass = variant === 'mega' ? 'site-mega-menu__item' : 'program-subnav__item';
  const linkClass = variant === 'mega' ? 'site-mega-menu__link' : 'program-subnav__link';
  const iconClass = variant === 'mega' ? 'site-mega-menu__icon' : 'program-subnav__icon';

  return (
    <ul className={listClass}>
      {items.map((item) => {
        const Icon = PROGRAM_SUBNAV_ICONS[item.icon] || FaQuestionCircle;
        const to = resolveProgramSubNavPath(slug, item, locale);
        const isHashLink = !item.path;
        const isActive = isHashLink && hash === `#${item.id}`;

        return (
          <li key={item.id} className={itemClass}>
            <Link
              to={isHashLink ? (onSamePage ? { pathname: basePath, hash: item.id } : basePath) : to}
              className={`${linkClass} ${isActive ? 'is-active' : ''}`}
              onClick={(e) => {
                if (isHashLink && onSamePage) {
                  e.preventDefault();
                  window.history.replaceState(null, '', `${basePath}#${item.id}`);
                  scrollToProgramSection(item.id);
                }
                onNavigate?.();
              }}
              onPointerDown={() => {
                if (variant === 'mega') {
                  onNavigate?.();
                }
              }}
            >
              <Icon className={iconClass} aria-hidden="true" />
              <span>{tProgramNavLabel(t, slug, item)}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default ProgramMegaMenuLinks;
